/* React */
import React from "react";

/* Ionic */
import { IonFabButton, IonIcon } from "@ionic/react";

/* Stylesheet */
import styles from "./PrimaryFabButton.module.scss";

/* Interfaces */
import { PrimaryFabButtonProps } from "src/shared/interfaces/common/PrimaryFabButton";

const PrimaryFabButton: React.FC<PrimaryFabButtonProps> = ({
  scssProps,
  className,
  ariaLabel,
  icon,
  disabled,
  onClick,
}) => {
  return (
    <IonFabButton
      data-testid="primary-fab-button"
      style={{
        margin: scssProps?.margin,
        position: scssProps?.position,
        height: scssProps?.height,
        width: scssProps?.width,
        top: scssProps?.top,
        left: scssProps?.left,
        right: scssProps?.right,
        bottom: scssProps?.bottom,
        "--color": scssProps?.color,
        "--background": scssProps?.background,
        "--box-shadow": scssProps?.boxShadow,
        zIndex: scssProps?.zIndex,
        icon: {
          height: scssProps?.icon?.height,
          width: scssProps?.icon?.width,
        },
      }}
      className={`${styles.primary_fab_button} ${className
        ?.split(" ")
        .map((cls) => styles[cls])
        .join(" ")} ${disabled ? styles.disabled : ""}`}
      aria-label={ariaLabel}
      size="small"
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        onClick!();
      }}
    >
      <IonIcon
        style={{
          height: scssProps?.icon?.height,
          width: scssProps?.icon?.width,
          color: scssProps?.color,
        }}
        className={styles.icon}
        icon={icon}
      />
    </IonFabButton>
  );
};

export default PrimaryFabButton;
